export default __webpack_public_path__ + "static/3-new-secret-c3ea22d645ccd1247207712c63424803.png";